/**
 * MFA step-up authentication API.
 * Ported from shipstation-lite/src/features/mfa/mfa-api.ts
 */

import { MFA_ENDPOINT_START_STEP_UP, MFA_ENDPOINT_START_CHALLENGE, MFA_ENDPOINT_SUBMIT_CHALLENGE } from './mfa-constants';
import { httpClient } from '../api/client';

import type {
  StartStepUpAuthRequest,
  StartStepUpAuthResponse,
  StartMfaChallengeRequest,
  StartMfaChallengeResponse,
  SubmitMfaChallengeRequest,
  SubmitMfaChallengeResponse,
} from './mfa-types';

/**
 * Start step-up authentication.
 * If isMfaRequired=false in the response, passwordless step-up succeeded.
 */
export const startStepUpAuth = async (req: StartStepUpAuthRequest): Promise<StartStepUpAuthResponse> => {
  const { data } = await httpClient.post<StartStepUpAuthResponse>(MFA_ENDPOINT_START_STEP_UP, req);
  return data;
};

/**
 * Start an MFA challenge for a specific enrollment.
 * Returns updated mfaToken + oobCode for OOB flows.
 */
export const startMfaChallenge = async (req: StartMfaChallengeRequest): Promise<StartMfaChallengeResponse> => {
  const { data } = await httpClient.post<StartMfaChallengeResponse>(MFA_ENDPOINT_START_CHALLENGE, req);
  return data;
};

/**
 * Submit an MFA challenge code.
 * `bindingCode` carries the user-entered value for oob challenges, `otpCode` for otp.
 * Returns elevated accessToken on success.
 */
export const submitMfaChallenge = async (req: SubmitMfaChallengeRequest): Promise<SubmitMfaChallengeResponse> => {
  const { data } = await httpClient.post<SubmitMfaChallengeResponse>(MFA_ENDPOINT_SUBMIT_CHALLENGE, req);
  return data;
};
